import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneBackendApiService } from '../../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import {
    GruppeTier,
    GruppeTierAbteilResult,
} from '../../../../../projects/kiene-core/src/lib/components/gruppe-tier/classes/gruppe-tier';

@Component({
    selector: 'kiene-abteil-aendern-dialog',
    templateUrl: './abteil-aendern-dialog.component.html',
    styleUrls: ['./abteil-aendern-dialog.component.scss'],
})
export class AbteilAendernDialogComponent implements OnInit {
    public abteilCtrl: FormControl = new FormControl();

    constructor(
        public dialogRef: MatDialogRef<AbteilAendernDialogComponent>,
        private api: KieneBackendApiService,
        private messageService: MessageService,
        @Inject(MAT_DIALOG_DATA) protected data: GruppeTier[],
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
    ) {}

    ngOnInit(): void {}

    public save(): void {
        this.api
            .post(this.apiBaseUrl + 'gruppe_tier/update_abteil.php', {
                abteil: this.abteilCtrl.value || '',
                tiere: this.data,
            })
            .subscribe({
                next: () => {
                    const result = new GruppeTierAbteilResult();
                    result.confirm = true;
                    this.dialogRef.close(result);
                },
                error: error => {
                    this.messageService.errorMessage('Fehler beim updaten der Abteile', error);
                },
            });
    }
}
